import { useState } from "react"
import { Container, ItemContainer, RadioBtn } from "./style"
import { BodyRegular } from "../../shared/typography"

interface ISwitchProps {
    toggle: Function
    items: IItem[]
}

interface IItem {
    name: string
    title: string
}

export const Switch = ({ items, toggle }: ISwitchProps) => {
    const [activeItem, setActiveItem] = useState<Partial<IItem>>({name: 'TYPE_1', title: 'Token Transfer'})
    const handleClick = (item: IItem) => {
        setActiveItem(item)
        toggle(item)
    }

    return (
        <Container>
            {
                items?.map((el: IItem) => {
                    return (
                        <ItemContainer gap="8px" onClick={() => handleClick(el)}>
                            <RadioBtn isActive={activeItem?.name === el?.name}/>
                            <BodyRegular color={activeItem?.name === el?.name ? '#191414' : '#A29B8B'} fontWeight='700'>{el?.title}</BodyRegular>
                        </ItemContainer>
                    )
                })
            }
        </Container>
    )
}